<template>
    <ul class="divide-y divide-solid divide-gray-500 text-left text-lg">
        <li
            v-for="(summaryGroup, i) in summaryGroups"
            :key="i"
            data-spec-class="summary__position"
        >
            <div
                v-for="position in positionsBy(summaryGroup)"
                :key="position.name"
                class="flex justify-between py-1"
            >
                <div>
                    <div class="flex items-center">
                        {{ position.name }}

                        <component
                            :is="position.component"
                            v-if="position.component"
                        >
                        </component>
                    </div>

                    <!-- eslint-disable vue/no-v-html -->
                    <div
                        class="-mt-1 text-base text-gray-400"
                        v-html="position.description"
                    ></div>
                </div>
                <!-- eslint-enable vue/no-v-html -->

                <div>
                    {{ $n(position.monthlyPrice || 0, 'currency') }}
                </div>
            </div>
        </li>
    </ul>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    summaryGroups: { type: Array, default: () => [] },
});

const positionsBy = (summaryGroup) => {
    if (summaryGroup instanceof Array) {
        return summaryGroup;
    }

    return [summaryGroup];
};
</script>
